module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blank"
  }, [_c('navbar', {
    attrs: {
      "templateName": "The DO"
    }
  }, [_c('select-template', {
    attrs: {
      "slot": "select"
    },
    on: {
      "template-selected": _vm.handleTemplateSelect
    },
    slot: "select"
  }, [_c('optgroup', {
    attrs: {
      "label": "Stories"
    }
  }, [_c('option', {
    attrs: {
      "value": "the-do-top-story"
    }
  }, [_vm._v("Top Story")]), _c('option', {
    attrs: {
      "value": "the-do-feature"
    }
  }, [_vm._v("Feature")]), _c('option', {
    attrs: {
      "value": "the-do-brief"
    }
  }, [_vm._v("Brief")])]), _c('optgroup', {
    attrs: {
      "label": "Other parts"
    }
  }, [_c('option', {
    attrs: {
      "value": "the-do-ad"
    }
  }, [_vm._v("Ad")]), _c('option', {
    attrs: {
      "value": "the-do-quote"
    }
  }, [_vm._v("Quote")]), _c('option', {
    attrs: {
      "value": "the-do-section-title"
    }
  }, [_vm._v("Section Title")]), _c('option', {
    attrs: {
      "value": "the-do-note"
    }
  }, [_vm._v("Note")]), _c('option', {
    attrs: {
      "value": "the-do-sponsored-content"
    }
  }, [_vm._v("Sponsored Content")]), _c('option', {
    attrs: {
      "value": "the-do-date",
      "selected": "selected"
    }
  }, [_vm._v("Date")])])])], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "appear": "appear",
      "mode": "out-in"
    }
  }, [_c(_vm.currentTemplate, {
    tag: "component",
    attrs: {
      "current-template": _vm.currentTemplate
    }
  })], 1), _c('div', {
    staticClass: "toast-container toast-top-right",
    attrs: {
      "id": "toastContainer"
    }
  }, [_c('div', {
    staticClass: "toast"
  }, [_c('button', {
    staticClass: "toast-close-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toastClose
    }
  }, [_vm._v("x")]), _c('div', {
    staticClass: "toast-title"
  }), _c('div', {
    staticClass: "toast-message"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-537eb186"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/TheDO.vue
// module id = 222
// module chunks = 0